import UserRfidModalNew from './UserRfidModalNew';

export default UserRfidModalNew;
